import { render } from "./RecentChapter.vue?vue&type=template&id=47d430f5&scoped=true"
import script from "./RecentChapter.vue?vue&type=script&lang=js"
export * from "./RecentChapter.vue?vue&type=script&lang=js"

import "./RecentChapter.vue?vue&type=style&index=0&id=47d430f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d430f5"]])

export default __exports__